import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  Heading,
  ListDisplay,
  MessageFoundation
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpen: boolean;
  fees: Array<{ label: string; value: string }>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeesDetails',
  props: {
    isOpen: { type: Boolean },
    fees: null
  },
  setup(__props: any) {



return { __sfc: true,Modal, Heading, ListDisplay, MessageFoundation }
}

})